<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تفاصيل الاشتراك #{{ id }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/packagesSubscriptions">اشتراكات الباقات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تفاصيل الاشتراك</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <successAlert v-if="hasSucess" :message="message" />
        <mainLoader v-if="mainLoading" />

        <div v-if="!mainLoading && row" class="row">
          <div class="col-12 col-lg-6">
            <div class="card card-secondary card-outline mb-4">
              <div class="card-header"><div class="card-title">بيانات الاشتراك</div></div>
              <div class="card-body">
                <table class="table table-sm">
                  <tbody>
                    <tr><th>العميل</th><td>{{ row.User? row.User.name : '-' }}</td></tr>
                    <tr><th>الجوال</th><td>{{ row.User? row.User.mobile : '-' }}</td></tr>
                    <tr>
                      <th>الباقة</th>
                      <td>
                        <router-link v-if="row.packageId" :to="`/mPackages/update/${row.packageId}`">{{ row.title }}</router-link>
                        <span v-else>{{ row.title }}</span>
                      </td>
                    </tr>
                    <tr><th>سعر الاشتراك</th><td>{{ row.price }} ر.س</td></tr>
                    <template v-if="row.couponId || row.Coupon || row.couponType">
                      <tr><th>كود الكوبون</th><td>{{ row.Coupon && row.Coupon.code ? row.Coupon.code : 'غير متوفر' }}</td></tr>
                      <tr v-if="row.Coupon && row.Coupon.title"><th>اسم الكوبون</th><td>{{ row.Coupon.title }}</td></tr>
                      <tr v-if="row.couponType"><th>نوع خصم الكوبون</th><td>{{ row.couponType === 'percentage' ? 'نسبة مئوية' : 'قيمة ثابتة' }}</td></tr>
                      <tr v-if="row.couponAmount != null"><th>قيمة خصم الكوبون</th><td>{{ row.couponAmount }} {{ row.couponType === 'percentage' ? '٪' : 'ر.س' }}</td></tr>
                      <tr>
                        <th>حالة الكوبون</th>
                        <td><span :class="row.couponAccepted ? 'badge bg-success' : 'badge bg-warning text-dark'">{{ row.couponAccepted ? 'مطبق' : 'لم يطبق' }}</span></td>
                      </tr>
                      <tr v-if="row.priceAfterDiscount != null"><th>سعر الاشتراك بعد الخصم</th><td>{{ row.priceAfterDiscount }} ر.س</td></tr>
                    </template>
                    <tr><th>وسيلة الدفع</th><td>{{ paymentGateLabel(row.paymentGate) }}</td></tr>
                    <tr><th>حالة السداد</th><td>{{ row.isPaid? 'تم السداد' : 'لم يتم السداد' }}</td></tr>
                    <tr>
                      <th>رقم عملية الدفع</th>
                      <td>
                        <router-link v-if="row.paymentId" :to="`/payments/update/${row.paymentId}`">#{{ row.paymentId }}</router-link>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <tr><th>حالة الاشتراك</th><td>{{ statusChoices[row.status] ?? row.status }}</td></tr>
                    <tr><th>المدة</th><td>{{ row.durationMonths }} شهر</td></tr>
                    <tr><th>تاريخ البداية</th><td>{{ row.startDate? $shortDate(row.startDate) : '-' }}</td></tr>
                    <tr><th>تاريخ الانتهاء</th><td>{{ row.expireDate? $shortDate(row.expireDate) : '-' }}</td></tr>
                    <tr>
                      <th>مرات الاستخدام</th>
                      <td>{{ row.usedVisits }} من {{ row.visitsCount }} (المتبقي {{ remainingVisits }})</td>
                    </tr>
                    <tr><th>نسبة الخصم</th><td>{{ row.discountPercentage }}%</td></tr>
                    <tr>
                      <th>الخدمات المشمولة</th>
                      <td>{{ issueNames(row.includedIssues) }}</td>
                    </tr>
                    <tr>
                      <th>خدمات الخصم</th>
                      <td>{{ issueNames(row.discountIssues) }}</td>
                    </tr>
                    <tr><th>مصدر الاشتراك</th><td>{{ requestSourceLabel(row.requestSource) }}</td></tr>
                    <tr v-if="row.cancelReason"><th>سبب الإلغاء</th><td>{{ row.cancelReason }}</td></tr>
                    <tr><th>تاريخ الاشتراك</th><td>{{ $shortDate(row.createdAt) }}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="card card-secondary card-outline mb-4">
              <div class="card-header"><div class="card-title">إدارة الاشتراك</div></div>
              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <div class="mb-3">
                    <label class="form-label">الحالة:</label>
                    <select v-model="status" class="form-control" :disabled="!canUpdate">
                      <option
                        v-for="(label, key) in statusChoices"
                        :key="key"
                        :value="key"
                        :disabled="!isEditableStatus(key)"
                      >{{ label }}</option>
                    </select>
                    <small v-if="status == 'exceeded'" class="text-muted">
                      حالة مستنفذ تُحدد تلقائياً. لتمديد الاشتراك، زِد عدد مرات الاستخدام واختر الحالة فعال.
                    </small>
                  </div>
                  <div class="row">
                    <div class="col-6 mb-3">
                      <label class="form-label">عدد مرات الاستخدام:</label>
                      <input type="number" v-model.number="visitsCount" class="form-control" :disabled="!canUpdate">
                    </div>
                    <div class="col-6 mb-3">
                      <label class="form-label">المستخدم منها:</label>
                      <input type="number" v-model.number="usedVisits" class="form-control" :disabled="!canUpdate">
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">تاريخ الانتهاء:</label>
                    <input type="date" v-model="expireDate" class="form-control" :disabled="!canUpdate">
                  </div>
                  <div v-if="status == 'canceled'" class="mb-3">
                    <label class="form-label">سبب الإلغاء:</label>
                    <input type="text" v-model="cancelReason" class="form-control" :disabled="!canUpdate">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">ملاحظات الإدارة:</label>
                    <textarea v-model="adminNote" class="form-control" rows="3" :disabled="!canUpdate"></textarea>
                  </div>
                </div>
                <div class="card-footer text-end">
                  <button v-if="canUpdate && !formLoader" type="submit" class="btn btn-success">حفظ</button>
                  <loader v-if="formLoader" />
                </div>
              </form>
            </div>
          </div>

          <div class="col-12">
            <div class="card card-secondary card-outline mb-4">
              <div class="card-header"><div class="card-title">سجل الاستخدام</div></div>
              <div class="card-body table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>نوع الاستخدام</th>
                      <th>الخدمة</th>
                      <th>رقم الطلب</th>
                      <th>قيمة الخدمة</th>
                      <th>قيمة الخصم</th>
                      <th>التاريخ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="usage in usages" :key="usage.id">
                      <td>{{ usage.id }}</td>
                      <td>
                        <span :class="usage.usageType == 'visit'? 'badge bg-success' : 'badge bg-info'">
                          {{ usage.usageType == 'visit'? 'زيارة مجانية' : 'خصم' }}
                        </span>
                      </td>
                      <td>{{ usage.MaintenanceIssue? usage.MaintenanceIssue.name : '-' }}</td>
                      <td>
                        <router-link v-if="usage.orderId" :to="`/orders/update/${usage.orderId}`">
                          #{{ usage.orderId }}
                        </router-link>
                        <span v-else>-</span>
                      </td>
                      <td>{{ usage.originalAmount }}</td>
                      <td>{{ usage.discountAmount }}</td>
                      <td>{{ $shortDate(usage.createdAt) }}</td>
                    </tr>
                    <tr v-if="!usages.length">
                      <td colspan="7" class="text-center text-muted">لم يتم استخدام الباقة حتى الآن</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'PackagesSubscriptionsUpdate',
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      row: null,
      usages: [],
      issues: [],
      statusChoices: {},
      status: null,
      visitsCount: 0,
      usedVisits: 0,
      expireDate: null,
      cancelReason: null,
      adminNote: null,
    }
  },
  computed: {
    canUpdate(){
      return checkAccess('packages_subscriptions_update');
    },
    remainingVisits(){
      if(!this.row)
        return 0;
      return Math.max((this.row.visitsCount ?? 0) - (this.row.usedVisits ?? 0), 0);
    },
  },
  methods: {
    checkAccess,
    issueNames(ids){
      if(!ids || !ids.length)
        return '-';
      return ids.map(id => {
        const issue = this.issues.find(item => item.id == id);
        return issue? issue.name : id;
      }).join(' ، ');
    },
    isEditableStatus(status){
      return ['waiting_payment', 'active', 'expired', 'canceled', 'payment_issue'].indexOf(status) != -1;
    },
    paymentGateLabel(paymentGate){
      const labels = {
        online: 'دفع إلكتروني',
        wallet: 'المحفظة',
        applepay: 'Apple Pay',
        admin: 'إضافة من لوحة التحكم',
      };
      return labels[paymentGate] ?? paymentGate ?? '-';
    },
    requestSourceLabel(source){
      const labels = {
        dashboard: 'لوحة التحكم',
        admin: 'لوحة التحكم',
        ios: 'iPhone',
        android: 'Android',
        website: 'الموقع الإلكتروني',
      };
      return labels[source] ?? source ?? '-';
    },
    getRowData(){
      this.$http.get(`/api/admin/mPackages/subscriptions/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.usages = data.row.UserPackageUsages ?? [];
        this.issues = data.issues ?? [];
        this.statusChoices = data.statusChoices ?? {};
        this.status = data.row.status;
        this.visitsCount = data.row.visitsCount;
        this.usedVisits = data.row.usedVisits;
        this.expireDate = data.row.expireDate? data.row.expireDate.substring(0, 10) : null;
        this.cancelReason = data.row.cancelReason;
        this.adminNote = data.row.adminNote;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    submitData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if(!this.isEditableStatus(this.status)){
        this.message = 'حالة مستنفذ تُحدد تلقائياً ولا يمكن حفظها يدوياً. اختر حالة أخرى أولاً.';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const payload = {
        status: this.status,
        visitsCount: this.visitsCount,
        usedVisits: this.usedVisits,
        expireDate: this.expireDate,
        cancelReason: this.cancelReason,
        adminNote: this.adminNote,
      };

      this.$http.put(`/api/admin/mPackages/subscriptions/update/${this.id}`, payload).then(({data}) => {
        this.row = {...this.row, ...data.row};
        this.message = 'تم التعديل بنجاح';
        this.hasSucess = true;
        this.formLoader = false;
        toast('تم التعديل بنجاح', 'success');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>